import React from "react";
import {Col, Row} from "antd";
import Preview from "./details/Preview";
import NameDesc from "./details/NameDesc";
import FileUpload from "./details/FileUpload";
import DateTime from "./details/DateTime";
import Category from "./details/Category";
import Participant from "./details/Participant";


const Details = ({formTitle, formDesc}) => {

    return (<>
        <div className="eform-content_head">
            <h2 className="eform-content_ttl">{formTitle}</h2>
            <p className="eform-content_desc">{formDesc}</p>
        </div>
        <div className="eform-content_body">
            <Row gutter={60}>
                <Col xs={24} sm={24} md={12} lg={12}>
                    <NameDesc />
                    <FileUpload />
                    <DateTime />
                    <Category />
                    <Participant />
                </Col>
                <Col xs={24} sm={24} md={12} lg={12}>
                    <Preview/>
                </Col>
            </Row>
        </div>
    </>)
}

export default Details;